<div class="tabs-container">
    <a ng-repeat="tab in vm.tabs" ng-class="{'selected': selectedTab === tab.id, 'pr-3 cursor-pointer d-flex': true}" 
       ng-click="vm.switchTab(tab)">
        <span ng-if="tab.rawName">{{tab.rawName}}</span>
        <span ng-if="tab.translateKey" translate="{{tab.translateKey}}"></span>
    </a>
</div>